import { Iterable } from 'immutable';

//import { isImmutable } from 'immutable'; // for immutable 4+, however, mediaElement stops working on iOS pre 10

/**
 * [immutableToJS
 *    converts properties of the provided [state] object from immutable
 *    data structures to regular JavaScript data structures - used with
 *    redux-logger
 *
 * @param  {object} state [state reference]
 * @return {object}       [transformed state]
 */
export default function immutableToJS(state) {
  return Object.keys(state).reduce((newState, key) => {
    const val = state[key];
    newState[key] = Iterable.isIterable(val) ? val.toJS() : val;
    //newState[key] = isImmutable(val) ? val.toJS() : val; //for immutable 4+
    return newState;
  }, {});
}